import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const scheduleApi = createApi({
  reducerPath: "schedule/api",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URL_DEVELOP}`,
    // baseUrl: `https://customer-api.techsbookdemo.com/api/v1`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("techsbook_customer_portal_token");
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
        headers.set("time", String(Date.now()));
      }

      return headers;
    },
  }),
  keepUnusedDataFor: 0.0001,
  endpoints: (build) => ({
    getProduct: build.query({
      query: ({ provider_id, job_id }) => ({
        url: `jobs/products/${provider_id}${job_id ? `?job_id=${job_id}` : ''}`,
        method: "GET",
      }),
    }),
    getVerificationText: build.mutation({
      query: () => ({
        url: `verification-text`,
        method: "GET",
      }),
    }),
    getTypeOfServices: build.query({
      query: (product_id) => ({
        url: `jobs/services/${product_id}`,
        method: "GET",
      }),
    }),
    getTechniciansForMonth: build.query({
      query: (params) => {
        const { durationMinutes, lat, lon, month, year, radius, job_except, product_ids } = params;
        let url = `technicians/for-month?durationMinutes=${durationMinutes}&lat=${lat}&lon=${lon}&month=${month}&year=${year}&radius=${radius}`;
        if (job_except) url += `&job_except[0]=${job_except}`;
        const uniqueProductIds = [...new Set(product_ids)]
        if (Array.isArray(uniqueProductIds) && uniqueProductIds.length > 0) {
          uniqueProductIds.forEach((id, index) => {
            url += `&product_ids[${index}]=${id}`;
          });
        }
        return { url, method: "GET" };
      },
    }),
    getTechniciansForJob: build.mutation({
      query: (params) => {
        const { duration, lat, lon, date, radius, job_except, product_ids } = params;
        let url = `technicians/for-job?duration=${duration}&lat=${lat}&lon=${lon}&date=${date}&radius=${radius}`;
        if (job_except) url += `&job_except[0]=${job_except}`;
        const uniqueProductIds = [...new Set(product_ids)]
        if (Array.isArray(uniqueProductIds) && uniqueProductIds.length > 0) {
          uniqueProductIds.forEach((id, index) => {
            url += `&product_ids[${index}]=${id}`;
          });
        }
        return { url, method: "GET" };
      },
    }),
    getTechnicianWorks: build.mutation({
      query: (params) => ({
        url: `technicians/schedule/${params.id}?start=${params?.start}&end=${params?.end}&lat=${params.lat}&lon=${params.lon}`,
        method: "GET",
      }),
    }),
    createJob: build.mutation({
      query: (body) => ({
        url: `jobs/create-job`,
        method: "POST",
        body,
        formData: true,
      }),
    }),
    rescheduleJob: build.mutation({
      query: ({jobId, body}) => ({
        url: `jobs/${jobId}/reschedule`,
        method: "POST",
        body,
        formData: true,
      }),
    }),
    getFieldsData: build.query({
      query: (data) => ({
        url: `prediction/primary-contacts?field=${data.field}&value=${data.value}`,
        method: "GET",
      }),
    }),
    getAffirmDueDays: build.mutation({
      query: (data) => ({
        url: `jobs/affirm-due-days`,
        method: "GET",
      }),
    }),
    getDistanceAndCost: build.query({
      query: (params)=> ({
        url: `technicians/distance-and-cost/${params.id}?duration=${params.duration}&lat=${params.lat}&lon=${params.lon}&date=${params.date}&radius=${params.radius}`,
        method: 'GET'
      })
    }),
  }),
});

export const {
  useGetProductQuery,
  useLazyGetTypeOfServicesQuery,
  useLazyGetTechniciansForMonthQuery,
  useGetTechniciansForJobMutation,
  useGetTechnicianWorksMutation,
  useCreateJobMutation,
  useLazyGetFieldsDataQuery,
  useGetVerificationTextMutation,
  useGetAffirmDueDaysMutation,
  useLazyGetDistanceAndCostQuery,
  useRescheduleJobMutation
} = scheduleApi;
